import styled from "styled-components";

import CenteredPage from "../components/CenteredPage";
import WalixHeader from "../components/WalixHeader";

const MainSection = styled.main`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;

  padding-top: calc(50vh - 108px);
`;

export default function Home() {
  return (
    <CenteredPage>
      <WalixHeader />

      <MainSection>En construcción.</MainSection>
    </CenteredPage>
  );
}
